import u from "dayjs";
import i from "dayjs/plugin/quarterOfYear";
import y from "dayjs/plugin/weekday";
import { range as l } from "lodash";
u.extend(y);
u.extend(i);
const c = (t) => ({
  month: t.month() + 1,
  year: t.year()
}), p = (t) => ({
  day: t.date(),
  month: t.month() + 1,
  year: t.year()
});
function d(t, r = !0) {
  const { day: n, month: o, year: e } = t || {}, f = r && n || 1, a = u(new Date(e, o - 1, f));
  return a.isValid() ? a : null;
}
function s(t, r) {
  const n = d(t);
  return n === null ? "" : n.format(r ? "MM/DD/YYYY" : "MM/YYYY");
}
function I(t, r, n) {
  return t && r ? `${s(t, n)} - ${s(r, n)}` : "";
}
function m(t) {
  return t < 100 ? t + 2e3 : t;
}
function O(t, r) {
  const n = t.split("/").map((e) => parseInt(e, 10)), o = u(
    r ? new Date(m(n[2]), n[0] - 1, n[1]) : new Date(m(n[1]), n[0] - 1, 1)
  );
  return o.isValid() ? {
    err: null,
    date: (r ? p : c)(o)
  } : {
    err: `Please enter a date in ${r ? "mm/dd/yyyy" : "mm/yyyy"} format.
        For example: ${r ? "10/31/2018" : "10/2018"}`,
    date: null
  };
}
const k = (t) => {
  const r = t.weekday(), n = t.clone().subtract(1, "month").daysInMonth();
  return l(
    n + 1 - r,
    n + 1
  );
}, D = (t, r) => t.year !== r.year ? t.year < r.year : t.month !== r.month ? t.month < r.month : !t.day || !r.day ? !0 : t.day <= r.day, Y = (...t) => {
  for (let r = 1; r < t.length; r += 1)
    if (!D(t[r - 1], t[r]))
      return !1;
  return !0;
}, T = (t, r, n, o, e, f, a) => {
  f === "end" ? e(t) : !a || !r ? n(t) : o ? (n(t), e(null)) : Y(r, t) ? e(t) : n(t);
}, b = (t) => `${t / 16}rem`;
export {
  Y as a,
  d as b,
  p as c,
  s as d,
  I as f,
  k as g,
  b as p,
  O as s,
  c as t,
  T as u
};
